import { render } from "./App.vue?vue&type=template&id=eb50fd22"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "/Users/xionglili/project/a_qn_project/changqin/platform-official-website/cq-official-website-vue-pc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__